import React from 'react';
import schema from '@/data/answerSchema.json';
import { CheckCircle2, Circle } from 'lucide-react';

function objectToLine(item) {
  var parts = [];
  var keys = Object.keys(item);
  for (var j = 0; j < keys.length; j++) {
    var v = item[keys[j]];
    if (v !== '' && v !== null && v !== undefined) {
      parts.push(String(v));
    }
  }
  return parts.join(' \u00b7 ');
}

function formatValue(val) {
  if (val === true) return 'Yes';
  if (val === false) return 'No';
  if (Array.isArray(val)) {
    var out = [];
    for (var i = 0; i < val.length; i++) {
      var item = val[i];
      var str;
      if (item && typeof item === 'object') {
        str = objectToLine(item);
      } else {
        str = String(item);
      }
      if (str) out.push(str);
    }
    return out;
  }
  return String(val);
}

function isEmpty(val) {
  if (val === null || val === undefined || val === '') return true;
  if (Array.isArray(val) && val.length === 0) return true;
  if (val === false) return true;
  return false;
}

function filledFieldKeys(rule, ruleData) {
  var keys = Object.keys(rule.fields);
  var filled = [];
  for (var i = 0; i < keys.length; i++) {
    if (!isEmpty(ruleData[keys[i]])) filled.push(keys[i]);
  }
  return filled;
}

function ListValue(props) {
  var lines = props.items;
  var lis = [];
  for (var i = 0; i < lines.length; i++) {
    lis.push(<li key={i}>{lines[i]}</li>);
  }
  return <ul className="list-disc list-inside">{lis}</ul>;
}

function FieldRow(props) {
  var value = formatValue(props.value);
  var isArr = Array.isArray(value);
  return (
    <div className="text-sm">
      <dt className="text-muted-foreground">{props.label}</dt>
      {isArr ? (
        <dd className="text-foreground"><ListValue items={value} /></dd>
      ) : (
        <dd className="text-foreground whitespace-pre-wrap">{value}</dd>
      )}
    </div>
  );
}

function RuleCard(props) {
  var rule = props.rule;
  var ruleData = props.ruleData || {};
  var completed = ruleData.completed === true;
  var filled = filledFieldKeys(rule, ruleData);

  var rows = [];
  for (var i = 0; i < filled.length; i++) {
    var fk = filled[i];
    rows.push(<FieldRow key={fk} label={rule.fields[fk]} value={ruleData[fk]} />);
  }

  return (
    <div className="bg-card border border-border rounded-lg p-4">
      <div className="flex items-center gap-2 mb-3">
        {completed ? (
          <CheckCircle2 className="h-4 w-4 text-emerald-600 shrink-0" />
        ) : (
          <Circle className="h-4 w-4 text-muted-foreground shrink-0" />
        )}
        <span className="font-medium text-sm">{rule.title}</span>
      </div>
      {rows.length === 0 ? (
        <p className="text-sm text-muted-foreground italic pl-6">Not started yet</p>
      ) : (
        <dl className="space-y-2 pl-6">{rows}</dl>
      )}
    </div>
  );
}

function SectionBlock(props) {
  var section = props.section;
  var data = props.data;
  var cards = [];
  for (var i = 0; i < section.rules.length; i++) {
    var rule = section.rules[i];
    cards.push(<RuleCard key={rule.key} rule={rule} ruleData={data[rule.key]} />);
  }
  return (
    <div>
      <h3 className="font-serif text-lg font-bold text-foreground mb-3 pb-2 border-b border-border">
        {section.title}
      </h3>
      <div className="space-y-4">{cards}</div>
    </div>
  );
}

function AnswersSummary(props) {
  var data = props.data || {};
  var blocks = [];
  for (var i = 0; i < schema.sections.length; i++) {
    var section = schema.sections[i];
    blocks.push(<SectionBlock key={section.title} section={section} data={data} />);
  }
  return (
    <div className="space-y-8" data-testid="answers-summary">{blocks}</div>
  );
}

export { AnswersSummary };
